import * as Sentry from '@sentry/vue';
import Vue from 'vue';

export function initializeSentry() {
    const dsn = process.env.VUE_APP_SENTRY_DSN;

    if (dsn !== '') {
        Sentry.init({Vue, dsn});
    }
}
